import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { selectModalData } from '../../../../redux/selectors/modal';
import { closeModal } from '../../../../redux/slices/modal';
import { PrimaryButton, SecondaryButton } from '../../../Button';
import KubitModal from '../../../KubitModal';
import { ModalActions } from '../../../KubitModal/KubitModalUI';

const SaveConfirmModal = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectModalData);
  const { onOk, onCancel } = data;

  const handleOk = () => {
    onOk();
    dispatch(closeModal());
  };

  const handleCancel = () => {
    onCancel();
    dispatch(closeModal());
  };

  return (
    <KubitModal
      header={'Unsaved Changes'}
      open={true}
      onClose={handleCancel}
      maxWidth={400}
    >
      <p>
        You have unsaved changes. Are you sure you want to leave without saving?
      </p>
      <ModalActions>
        <SecondaryButton
          onClick={handleCancel}
          trackContext="reports"
          trackAction="save confirm - no"
        >
          No
        </SecondaryButton>
        <PrimaryButton
          onClick={handleOk}
          trackContext="reports"
          trackAction="save confirm - yes"
        >
          Yes
        </PrimaryButton>
      </ModalActions>
    </KubitModal>
  );
};

export default SaveConfirmModal;
